import type { UseLalSegmentPermissions } from '@openx/components-segment/lib/utils/context/SegmentHookTypes.ts';
import { useAuth } from '../../../components/AuthContext/context.ts';
import { isInternalAdmin } from '../../../permissions/validators.ts';

export const useLalSegmentPermissions: UseLalSegmentPermissions = () => {
  const { session } = useAuth();

  const shouldSeeOnBehalfOf = isInternalAdmin(session);

  return {
    shouldSeeOnBehalfOf,
  };
};
